import React from 'react';
import { Link } from 'react-router-dom';

import { breakpoints, colors, css, fluidRange, fontSmoothing, respondFrom, styled } from '~/styles';
import LogoImg from '~/assets/images/revance-studio-logo-white-v2.svg';

import config from '~/config';

const StyledLogoContainer = styled.div`
  max-height: 100%;
  ${fluidRange('marginRight', '15px', '60px', breakpoints.lg, breakpoints.max)};
  flex-shrink: 0;

  a {
    height: 100%;
    padding: 0;

    display: flex;
    flex-flow: row;
    align-items: center;
  }

  img, svg {
    width: 210px;
    height: 100%;
    max-width: 35vw;
    margin-top: -1px;

    ${respondFrom(breakpoints.lg, css`
      max-width: 20vw;
    `)};
  }

  span {
    ${fluidRange('fontSize', '12px', '26px', breakpoints.xs, breakpoints.md)};
    font-weight: 300;
    ${fontSmoothing};
    text-transform: uppercase;
    display: inline-block;
    line-height: 1;
    letter-spacing: 0.15em;
    ${fluidRange('paddingLeft', '15px', '22px', breakpoints.lg, breakpoints.max)};
    ${fluidRange('marginLeft', '15px', '22px', breakpoints.lg, breakpoints.max)};

    transform: translateY(10%);

    &:before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      height: 140%;
      top: 50%;
      transform: translateY(-60%);
      width: 1px;
      background: ${colors.white};
    }
  }
`

function SiteBranding() {
  return (
    <StyledLogoContainer>
      <Link to='/resources'  title={config.title}>
        <img src={LogoImg} alt='RevanceU' />
        {/* <span>St<strong>u</strong>dio</span> */}
        <span>Gallery</span>
      </Link>
    </StyledLogoContainer>
  );
}

export default SiteBranding;



// WEBPACK FOOTER //
// ./src/components/layout/header/PageHeaderBranding.tsx